export default __webpack_public_path__ + "static/media/ts_off.60512003.png";